import { Divider } from '@mui/material';

export const FilterDivider = () => {
  return <Divider sx={{ my: 1 }} />;
};
